const auxiliaryTypeCodes = {
  irregular: 458,
  regular: 459,
};

export default auxiliaryTypeCodes;
